import React, { useContext, useEffect, useState } from "react";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import { TbWorld } from "react-icons/tb";
import Footer from "../../component/Footer/Footer";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import getBundleDetails from "../../services/api/eSim/getBundleDetails";
import { AuthUserContext } from "../../context/context";
import Spinner from "react-bootstrap/esm/Spinner";
import checkoutSession from "../../services/stripe/checkoutSession";
import validateWebsiteCoupon from "../../services/coupons/validateWebsiteCoupon";
import { useLocation } from "react-router-dom";
import Navbars from "../../component/Navbar/Navbar";
import esimVaultSvg from "../../assets/images/esimVault.svg";
import RegistrationPopup from "../../component/RegistrationPopup";
import { AiOutlineInfoCircle } from "react-icons/ai";


import {
  CURRENCY,
  USER_DETAILS,
} from "../../constants/localstorageKeys";
import currencyExchange from "../../services/api/currencyyExchange";
import RegisterOffers from "../../component/RegisterOffers";
import {
  countryCode,
  countryCurrency,
  currencySymbols,
} from "../../constants/currency";
import CurrencyNameSelect from "../../component/CurrencyNameSelect";
import { useParams } from "react-router-dom";
import userProfile from "../../services/auth/userProfile";
import { parsePhoneNumberFromString } from "libphonenumber-js/min";
import { countryList } from "../../constants/countryList";
import { Modal, Overlay } from "react-bootstrap";
import { useRef } from "react";

const OfferDetail = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showCouponModal, setShowCouponModal] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [couponLoading, setCouponLoading] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponError, setCouponError] = useState("");
  const [businessRecipet, setBusinessReciept] = useState(false);
  const [bundleDetail, setBundleDetails] = useState([]);
  const [exchangeRate, setExchangeRate] = useState(1);
  const [currencySymbol, setCurrencySymbol] = useState("$");
  const [show, setShow] = useState(false);
  const infoRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { id, key } = useParams();
  const {
    currentLocalization,
    user,
    countryCodes,
    setToastId,
    setOutSideUserPhoneNo,
    setUserGoogleId,
    setGooglePhoneNo,
  } = useContext(AuthUserContext);
  const newuser = JSON.parse(localStorage.getItem(USER_DETAILS));

  const getCurrency = localStorage.getItem(CURRENCY);
  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const handleCurrencyChange = ({ exchangeRate, currency }) => {
    setExchangeRate(exchangeRate);
    setCurrencySymbol(currency);
  };
  const bundleDetails = async () => {
    try {
      const response = await currencyExchange();
      if (id && key) {
        const response = await getBundleDetails(id, key, currentLocalization);
        if (response.success) {
          setBundleDetails(response?.data);
          
        }
      } else {
        navigate("/");
      }
    } catch (err) {
      const id = toast.error(err.response?.data?.message || err.message, {
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        pauseOnHover: true,
      });
      setToastId(id);
    } finally {
      setLoading(false);
    }
  };

  const normalizePhoneNumber = (phone) => {
  if (!phone) return null;

  const trimmed = phone.trim();

  // If it already starts with +, return as-is
  if (trimmed.startsWith("+")) {
    return trimmed;
  }

  // Otherwise, prepend +
  return `+${trimmed}`;
}
  const createWebsiteCheckoutSession = async (useCoupon) => {
    try {
      setButtonLoading(true);

      const sessionData = {
        package_id: bundleDetail.package_id || id,
        key: key,
        lang: currentLocalization,
        currency: getCurrency,
        businessReceipt: businessRecipet,
      };
      const referrer = localStorage.getItem("referrer");
      if (referrer) {
        sessionData.referrer = referrer;
      }
      if (useCoupon && appliedCoupon?.couponCode) {
        sessionData.couponCode = appliedCoupon.couponCode;
      }

      const response = await checkoutSession(sessionData);
      if (response) {
        setRedirectUrl(response.url);
        window.location.href = response.url;
      }
    } catch (err) {
      setButtonLoading(false);
      const id = toast.error(err.response?.data?.message || err.message, {
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        pauseOnHover: true,
      });
      setToastId(id);
    } finally {
      setButtonLoading(false);
    }
  };

  const handleBuyNowClicked = async () => {
    try {
      if (!newuser) {
        setShowModal(true);
        return;
      }

      const user = await userProfile();

      if (bundleDetail.isFree && user?.data?.isFreeSim) {
        toast.error("Already claimed free SIM for this account.");
        return;
      }
      
      const userPhoneNo = normalizePhoneNumber(user?.data?.phone_no);

      const userCountry = await getCountryFromPhone(userPhoneNo);

      if(userCountry && userCountry === bundleDetail.country) {
        toast.error("You can not buy this bundle from your country.");
        return;
      }

      setCouponCode("");
      setAppliedCoupon(null);
      setCouponError("");
      setShowCouponModal(true);
    } catch (err) {
      setButtonLoading(false);
      const id = toast.error(err.response?.data?.message || err.message, {
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        pauseOnHover: true,
      });
      setToastId(id);
    } finally {
      setButtonLoading(false);
    }
  };

  const currencyCHange = async () => {
    try {
      if (getCurrency) {
        const newCode = countryCodes ? countryCodes : getCurrency;
        const getCountryCurrency = countryCurrency.find(
          (code) => code.currency_code === newCode
        );
        const country = countryCode.find(
          (country) => country.countryName === getCountryCurrency.country_code
        );
        const newCurrency = country ? country.countryCurrency : "USD";
        const currencyCode =
          currencySymbols.find((symbol) => symbol.Code === newCurrency)
            ?.Symbol ?? newCode;
        setCurrencySymbol(currencyCode);
        setSelectedCurrency(newCurrency);
        const response = await currencyExchange();
        const exchangeRate = response.rates[newCurrency];
        setExchangeRate(exchangeRate);
      }
    } catch (e) {
      console.log("e", e);
    }
  };
  const renderCountries = (countries) => {
    if (!countries) return "";

    let moreDestinationsPattern;
    switch (currentLocalization) {
      case "en":
        moreDestinationsPattern = /\d+ more destinations/;
        break;
      case "fr":
        moreDestinationsPattern = /\d+ plus de destinations/;
        break;
      case "in":
        moreDestinationsPattern = /\d+ lebih banyak tujuan/;
        break;
      case "ar":
        moreDestinationsPattern = /\d+ المزيد من الوجهات/;
        break;
      default:
        moreDestinationsPattern = /\d+ more destinations/;
    }

    const match = countries.match(moreDestinationsPattern);
    if (match) {
      const moreDestinationsText = match[0];
      const cleanedCountries = countries.replace(moreDestinationsPattern, "");
      return (
        <span>
          {cleanedCountries.trim()}
          &nbsp;
          <a href="#more-countries" className="offers-works-span-a">
            {moreDestinationsText}
          </a>
        </span>
      );
    }

    return <span>{countries}</span>;
  };

  const getCountryFromIso = (iso) => {

    if(!iso) return null;

    const country = countryList.find(c => c.cca2 === iso.toUpperCase());
    return country?.name?.common || null;
  }
  const getCountryFromPhone = async (phoneNumber) => {

    try{
      const parsed = parsePhoneNumberFromString(phoneNumber);
      const iso = parsed?.country;

      return getCountryFromIso(iso);
    }catch(error){
      console.error("Phone parsing error:", error);
      return null
    }
  }

  useEffect(() => {
    currencyCHange();
  }, [getCurrency]);
  useEffect(() => {
    bundleDetails();
  }, []);

  const handleModalClose = async (isSubmit) => {
    setShowModal(false);
    setUserGoogleId("");
    setGooglePhoneNo("");
    if (isSubmit) {
      setOutSideUserPhoneNo("");
      setCouponCode("");
      setAppliedCoupon(null);
      setCouponError("");
      setShowCouponModal(true);
    }
  };

  const handleTooltip = () => {
    setShow(prev => !prev);
  }

  const displayedDiscountedPrice =
    appliedCoupon?.discountedPrice != null
      ? Number(appliedCoupon.discountedPrice) * exchangeRate
      : null;
  const checkoutButtonLabel = couponError
    ? "Continue without coupon"
    : appliedCoupon
    ? "Continue"
    : "Continue without coupon";

  const handleCouponChange = (event) => {
    setCouponCode(event.target.value);
    setAppliedCoupon(null);
    setCouponError("");
  };

  const handleApplyCoupon = async () => {
    const code = couponCode.trim();
    if (!code) {
      setCouponError("Enter a coupon code.");
      setAppliedCoupon(null);
      return;
    }

    try {
      setCouponLoading(true);
      const response = await validateWebsiteCoupon({
        couponCode: code,
        package_id: bundleDetail.package_id || id,
        key,
      });
      setAppliedCoupon(response.data);
      setCouponCode(response.data.couponCode);
      setCouponError("");
    } catch (err) {
      setAppliedCoupon(null);
      setCouponError(err.response?.data?.message || err.message);
    } finally {
      setCouponLoading(false);
    }
  };

  const handleContinueFromCouponModal = () => {
    createWebsiteCheckoutSession(Boolean(appliedCoupon));
  };

const privacyPopover = (
  <div id="privacy-popover" className="custom-popover">
    Lower speed rate of 1 Mbps after 3 GB usage per day.
  </div>
);

  return (
    <>
      <Navbars />
      <Container>
        {newuser ? null : (
          <Row className="pt-4">
            <Col className="text-start p-0 me-1 ms-1 ms-lg-0 me-lg-0">
              <RegisterOffers />{" "}
            </Col>
          </Row>
        )}
        <Row className="offer-card-display p-0 me-1 ms-1 ms-lg-0 me-lg-0">
          <Col md={12} className="p-0 d-flex justify-content-end mt-4">
            <Col md={1} xs={12} className="">
              <CurrencyNameSelect
                onCurrencyChange={handleCurrencyChange}
                selectedCurrency={selectedCurrency}
                setSelectedCurrency={setSelectedCurrency}
                value="home"
              />
            </Col>
          </Col>
          {loading ? (
            <div
              className="w-100"
              style={{ paddingTop: "80px", paddingBottom: "80px" }}
            >
              <Spinner animation="border" variant="dark" />
            </div>
          ) : (
            <Col
              md={12}
              xs={12}
              className="offer-card-box-green-offer mb-5 p-0 mt-4"
            >
              <Col
                md={12}
                xs={12}
                className="offer-card-box-top-green-details p-2"
              >
                <Row
                  className={`d-flex align-items-center justify-content-between mt-2 mb-2 ${
                    currentLocalization == "ar"
                      ? "flex-row-reverse"
                      : "flex-row"
                  }`}
                >
                  <Col
                    lg={5}
                    md={4}
                    xs={12}
                    className={`d-flex align-items-center ms-2 ${
                      currentLocalization == "ar"
                        ? "flex-row-reverse"
                        : "flex-row"
                    }`}
                  >
                    <div className="d-flex align-items-center">
                      <img
                        src={
                          bundleDetail?.key === "esimVault"
                            ? esimVaultSvg
                            : bundleDetail?.imageUrl
                        }
                        alt="offer-icon"
                        width={55}
                        height={55}
                        style={{ borderRadius: "50%" }}
                      />
                    </div>
                    <Row
                      className={`${
                        currentLocalization == "ar" ? "me-1" : "ms-1"
                      }`}
                    >
                      <Col
                        md={12}
                        xs={11}
                        className={`${
                          currentLocalization == "ar"
                            ? "d-flex flex-row-reverse "
                            : "text-start d-flex justify-content-start"
                        }`}
                      >
                        <h3 className="global-h3-details mt-2 ps-1">
                          {bundleDetail?.description}
                        </h3>
                      </Col>
                      <Col md={12} xs={11}>
                        <div
                          className={`offers-works-span text-start d-flex  ${
                            currentLocalization == "ar"
                              ? "d-flex flex-row-reverse"
                              : ""
                          }`}
                        >
                          <span>
                            <TbWorld size={17} />
                          </span>
                          <span
                            style={{ marginTop: "2px" }}
                            className={
                              currentLocalization == "ar" ? "pe-1" : "ps-1"
                            }
                          >
                            <b>
                              {renderCountries(
                                `${t("countryFilter.part31")} ${t(
                                  `countryName.${bundleDetail?.country}`
                                )}${
                                  bundleDetail?.countries_count
                                    ? ` & ${
                                        bundleDetail?.countries_count - 1
                                      } ${t("countryFilter.part32")}`
                                    : ""
                                }`
                              )}
                            </b>
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={5} md={4} xs={12}>
                    <Row
                      className={`d-flex  ${
                        currentLocalization === "ar"
                          ? "justify-content-start"
                          : "justify-content-end"
                      }`}
                    >
                      <Col
                        lg={3}
                        md={3}
                        xs={4}
                        className={`d-flex  flex-column p-0 mt-3 mb-2 ${
                          currentLocalization === "ar"
                            ? "pe-4 text-end"
                            : "text-start ps-4"
                        }`}
                        style={{ borderRight: "1px solid #DEDEDE" }}
                      >
                        <span className="offer-validity-span ">
                          {t("home.part18")}
                        </span>
                        {currentLocalization === "ar" ? (
                          <div className="d-flex align-items-center justify-content-end">
                            <span className="offer-days-span ">
                              {t("home.part21")}
                            </span>
                            <span className="offer-days-span">
                              {" "}
                              &nbsp;{bundleDetail?.duration}
                            </span>
                          </div>
                        ) : (
                          <span className="offer-days-span ps-1">
                            {bundleDetail?.duration} {t("home.part21")}
                          </span>
                        )}
                      </Col>
                      <Col
                        md={3}
                        xs={3}
                        className={`d-flex flex-column  mt-3 mb-2 ${
                          currentLocalization === "ar"
                            ? "pe-4 text-end"
                            : "text-start align-items-center"
                        }`}
                        style={{ borderRight: "1px solid #DEDEDE" }}
                      >
                        <span className="offer-validity-span p-0">
                          {t("home.part19")}
                        </span>
                        {currentLocalization === "ar" ? (
                          <div className="d-flex align-items-center justify-content-end">
                            <span className="offer-days-span">
                              {bundleDetail?.dataAmount > 0 && t("home.part22")}
                            </span>
                            <span className="offer-days-span">
                              {" "}
                              &nbsp;
                              {bundleDetail?.dataAmount <= 0
                                ? t("home.part33")
                                : bundleDetail?.dataAmount}
                            </span>
                          </div>
                        ) : (
                          <span className="offer-days-span ">
                            {bundleDetail?.dataAmount <= 0
                              ? t("home.part33")
                              : bundleDetail?.dataAmount}{" "}
                            {bundleDetail?.dataAmount > 0 && t("home.part22")}
                          </span>
                        )}
                      </Col>
                      <Col
                        md={3}
                        xs={3}
                        className="d-flex flex-column text-start ps-3 p-0 mt-3 mb-2"
                      >
                        <span
                          className={`offer-validity-span ${
                            currentLocalization === "ar" ? "ps-3" : "p-0"
                          }`}
                        >
                          {t("home.part20")}
                        </span>
                        <span
                          className="offer-days-span"
                        >
                          {bundleDetail?.isFree ? (
                            t("free")
                          ) : currencySymbol == "Rp" ? (
                            <>
                              {currencySymbol}&nbsp;
                              {(bundleDetail?.price * exchangeRate).toFixed(0)}
                            </>
                          ) : (
                            <>
                              {currencySymbol}&nbsp;
                              {(bundleDetail?.price * exchangeRate).toFixed(2)}
                            </>
                          )}
                        </span>
                      </Col>
                    </Row>
                    {user && user.parent_id ? null : (
                      <Row>
                        <Col className="ms-4" lg={12} md={10} xs={12}>
                          <AiOutlineInfoCircle size={12} />
                          <span className="offer-charges-applied">
                            {t("  Payment processing fees are non-refundable.")}
                          </span>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col
                    md={12}
                    xs={12}
                    style={{ position: "relative" }}   // <-- Add this
                    className={`text-start mt-3 ps-4 pe-4 d-flex flex-wrap position-relative ${
                      currentLocalization === "ar" && "flex-row-reverse"
                    }`}
                  >
                    <p className="home-time-span text-start">
                       {bundleDetail?.isUnlimited && (
                        
                        <div style={{ position: "relative", display: "inline-block", cursor: "pointer" }} className="pe-auto">
                            <span
                              className="text-success ms-1 me-1 pe-auto"
                              ref={infoRef}
                              onClick={handleTooltip}
                            >
                              ⓘ 
                            </span>

                            <Overlay
                              target={infoRef.current}
                              show={show}
                              placement="bottom-start"
                              rootClose
                              onHide={() => setShow(false)}
                            >
                              {privacyPopover}
                            </Overlay>
                          </div>

                                )}
                      {bundleDetail?.description}

              
                              </p>
                            </Col>
                          </Row>

                <Row
                  className={`d-flex justify-content-end p-3 col-12 ${
                    currentLocalization === "ar" && "flex-row-reverse"
                  }`}
                >
                  <Col
                    md={currentLocalization == "ar" ? 4 : 4}
                    xs={12}
                    className={
                      currentLocalization == "ar"
                        ? "ms-md-5 p-0"
                        : "p-0"
                    }
                  >
                    <div className="flex flex-col  ">
                    <div
                      className={`gap-2 align-items-center flex-column d-flex ${
                        currentLocalization == "ar"
                          ? "justify-content-start me-3"
                          : "justify-content-center"
                      }`}
                    >
                      <button
                        className={
                          buttonLoading || user?.role == "admin" || (newuser?.isFreeSim && bundleDetail?.isFree)
                            ? "view-offer-button-buy-disabled"
                            : `${
                                currentLocalization == "ar"
                                  ? "view-offer-button-buy-ar"
                                  : "view-offer-button-buy"
                              }`
                        }
                        size="lg"
                        onClick={handleBuyNowClicked}
                        disabled={buttonLoading || user?.role == "admin" || (newuser?.isFreeSim && bundleDetail?.isFree)}
                      >
                        {buttonLoading ? (
                          <>
                            {currentLocalization == "ar" ? (
                              <>
                                <span className="me-2">
                                  ... {t("login.part16")}
                                </span>
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />
                              </>
                            ) : (
                              <>
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />
                                <span className="ms-2">
                                  {t("login.part16")} ...
                                </span>
                              </>
                            )}
                          </>
                        ) : (
                          <>{t("home.part27")}</>
                        )}
                      </button>
                      <label
                        style={{ width: '100%', fontWeight: '400', fontSize: '0.85rem', display: 'flex', alignItems: 'center', justifyContent: 'center', itemsAlign: 'center', gap: '0.4rem', cursor: 'pointer' }}
                        >
                        <input
                          type="checkbox"
                          style={{ width: '16px', height: '16px' }}
                          checked={businessRecipet}
                          onChange={(e) => setBusinessReciept(e.target.checked)}
                        />
                        <span>{t("I'm travelling for business.")}</span>
                      </label>
                      </div>
                    </div>
                  </Col>
                </Row>
                <RegistrationPopup
                  show={showModal}
                  handleClose={handleModalClose}
                />
                <Modal
                  show={showCouponModal}
                  onHide={() => !buttonLoading && setShowCouponModal(false)}
                  centered
                >
                  <Modal.Header closeButton={!buttonLoading}>
                    <Modal.Title>Have a coupon?</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="website-coupon-box">
                      <div className="website-coupon-row">
                        <input
                          className="website-coupon-input"
                          value={couponCode}
                          onChange={handleCouponChange}
                          placeholder="Coupon code"
                          disabled={couponLoading || buttonLoading}
                        />
                        <button
                          type="button"
                          className="website-coupon-apply"
                          onClick={handleApplyCoupon}
                          disabled={couponLoading || buttonLoading || Boolean(appliedCoupon)}
                        >
                          {couponLoading ? "Applying..." : "Apply"}
                        </button>
                      </div>
                      {appliedCoupon ? (
                        <div className="website-coupon-success">
                          Coupon applied. New total: {currencySymbol}
                          {currencySymbol == "Rp"
                            ? displayedDiscountedPrice.toFixed(0)
                            : displayedDiscountedPrice.toFixed(2)}
                        </div>
                      ) : null}
                      {couponError ? (
                        <div className="website-coupon-error">{couponError}</div>
                      ) : null}
                    </div>
                  </Modal.Body>
                  <Modal.Footer className="website-coupon-modal-footer">
                    <button
                      type="button"
                      className={
                        buttonLoading
                          ? "view-offer-button-buy-disabled"
                          : "view-offer-button-buy"
                      }
                      onClick={handleContinueFromCouponModal}
                      disabled={buttonLoading || couponLoading}
                    >
                      {buttonLoading ? (
                        <>
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                          <span className="ms-2">{t("login.part16")} ...</span>
                        </>
                      ) : (
                        <>{checkoutButtonLabel}</>
                      )}
                    </button>
                  </Modal.Footer>
                </Modal>
              </Col>
            </Col>
          )}
          <Col
            md={12}
            xs={12}
            className="offer-details-box text-start p-4 mt-3 mb-5 "
          >
            <div
              className={
                currentLocalization == "ar" ? " text-end" : "text-start"
              }
            >
              <p className="offer-instant-p">{t("detailsPage.part1")}</p>
              <ul
                className="offer-list ms-md-4 "
                style={{ direction: currentLocalization == "ar" && "rtl" }}
              >
                <li>⚠️ {t("detailsPage.part2")}</li>
                <li>{t("detailsPage.part3")}</li>
                <li>{t("detailsPage.part4")}</li>
                <li>{t("detailsPage.part5")}</li>
                <li>{t("detailsPage.part6")}</li>
                <li>{t("detailsPage.part7")}</li>
                <li>{t("detailsPage.part8")}</li>
                <li>{t("detailsPage.part6")}</li>
              </ul>
            </div>
          </Col>
          <Col
            md={12}
            xs={12}
            className="offer-details-box text-start p-4 mt-3 mb-5"
            id="more-countries"
          >
            <p
              className={`offer-instant-p ${
                currentLocalization == "ar" ? " text-end" : "text-start"
              }`}
            >
              {t("detailsPage.part10")}
            </p>
            <Row className="">
              {bundleDetail &&
                bundleDetail.countriesArray &&
                bundleDetail.countriesArray.map((country) => {
                  // Split the country name at the first '(' and take the part before it
                  const countryName = country.name.split(" (")[0];

                  return (
                    <Col
                      md={3}
                      className="mt-2 d-flex align-items-start"
                      key={country.iso}
                    >
                      <img
                        src={`https://flagcdn.com/32x24/${country.iso.toLowerCase()}.png`}
                        width="22"
                        height="18"
                        alt={`${country.iso} flag`}
                        className="mt-1"
                      />
                      &nbsp;
                      <span className="country-names">{countryName}</span>
                    </Col>
                  );
                })}
            </Row>
          </Col>
        </Row>
        <Row className="d-flex justify-content-center">
          <Col className="m-0 p-0" md={12} xs={11}>
            <Footer />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default OfferDetail;
